//import { useGrid } from "common";
import { useParams } from "common/components/Form/ParamsContext";
import { useFilter } from "components/FilterProvider";
import { useMemo, useState } from "react";
import { getScheduleService } from "./scheduleApi";

export type ScheduleFilter = {
  includeExpired?: boolean;
  range?: { start?: string; end?: string };
  boatIds?: number[];
  programIds?: number[];
};

export default function useScheduleList() {
  const params = useParams<"boat_id">();
  const [filter, onChange] = useFilter<ScheduleFilter>();
  const [showMore, setShowMore] = useState<boolean>();
  const scope = { boats: params.boat_id };
  const editUrl = `${
    Object.values(scope || {}).filter(v => !!v).length > 0 ? "schedules/" : ""
  }`;
  const service = getScheduleService(scope);

  const gridFilter = useMemo(() => {
    let f: any = [];

    if (filter?.includeExpired) {
      // Ha be van pipálva, akkor mutassa az összes menetrendet
      // Nincs szűrés a date_to alapján
    } else {
      // Ha nincs bepipálva, akkor csak az aktívakat mutassa (ahol date_to >= mai nap)
      const today = new Date().toISOString().split("T")[0];
      f.push({
        columnField: "date_to",
        operatorValue: "gte",
        value: today,
      });
    }

    if (filter?.range?.start && filter?.range?.end) {
      f.push(
        {
          columnField: "date_from",
          operatorValue: "lte",
          value: filter.range.end,
        },
        {
          columnField: "date_to",
          operatorValue: "gte",
          value: filter.range.start,
        },
      );
    }

    if (filter?.boatIds?.length) {
      f.push({
        columnField: "boat_id",
        operatorValue: "in",
        value: filter.boatIds,
      });
    }

    if (filter?.programIds?.length) {
      f.push({
        columnField: "scheduleProgramIds",
        operatorValue: "in",
        value: filter.programIds,
      });
    }

    return f;
  }, [filter]);

  return {
    ...service,
    params,
    scope,
    editUrl,
    filter,
    onChange,
    gridFilter,
    showMore,
    setShowMore,
  };
}
